module.exports = __webpack_public_path__ + "img/clouds.ba4dd3ec.jpg";